<template>
  <div class="cart-container" data-aos="zoom-in">
    <h1 class="cart-heading">{{ title }}</h1>
    <img src="/images/smile.svg" alt="" class="smile" />
    <p class="cart-article-1">
      Ooops... You don't have any items in your {{ itemName }}.
    </p>
    <p class="cart-article-2">Let's browse something you want together.</p>
    <div class="cart-buttons">
      <router-link :to="{ name: 'Home' }"
        ><base-button>Go to store</base-button></router-link
      >
      <router-link :to="to"
        ><add-button>Go to {{ whereToGoButton }}</add-button></router-link
      >
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    itemName: {
      type: String,
      required: true,
    },
    whereToGoButton: {
      type: String,
      required: true,
    },
    to: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.cart-container {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 30px;
  padding: 65px;
}

.cart-heading {
  color: #000;
  font-family: "Glusp";
  font-size: 3.6rem;
  font-weight: 700;
  margin-bottom: 30px;
}

.cart-article-1 {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.8rem;
  font-weight: 500;
  max-width: 350px;
  text-align: center;
}

.cart-article-2 {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;
  max-width: 270px;
  text-align: center;
  margin-bottom: 45px;
}

.cart-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
}

@media screen and (min-width: 320px) and (max-width: 480px) {
  .cart-heading {
    text-align: center;
    font-size: 3rem;
  }
  .smile {
    height: 150px;
  }
  .cart-article-1 {
    font-size: 2.3rem;
  }
  .cart-article-2 {
    font-size: 2.1rem;
  }
  .cart-buttons {
    flex-direction: column;
    gap: 15px;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .cart-heading {
    text-align: center;
    font-size: 3rem;
  }
  .smile {
    height: 200px;
  }
  .cart-buttons {
    flex-direction: column;
    gap: 15px;
  }
  
}
</style>